import styled from "@emotion/styled";
import { Col, Image, Row, Tag } from "antd";
import { FC, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { FileLine } from "../../module/files/components/FileLine";
import { NewsEntity } from "../../module/news/entity/news.entity";
import newsService from "../../module/news/service/news.service";

export const NewsDetail: FC = () => {
	const [info, setInfo] = useState<NewsEntity>({});

	const { id } = useParams();

	const init = useCallback(async () => {
		const { data } = await newsService.detail(Number(id));
		setInfo(data);
	}, [id]);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	const breadArr = [
		{
			title: "新闻中心",
			link: "/newsroom",
		},
		{
			title: info.title,
		},
	];

	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/images/2022-05-28/1653669230.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>{info.title}</h1>
				</div>
				<Bread value={breadArr} />
				<div>
					{info.publishDate} | <Tag color={"blue"}>{info.newsTypeTitle}</Tag>
				</div>
				<Row className="inner-content">
					<Col lg={14} md={14} xs="24" dangerouslySetInnerHTML={{__html: info.content??""}} />
					<Col lg={8} md={8} xs={24}>
						<Image src={info.image} preview={false} />
						<div>
							{info.imageDescription}
						</div>
					</Col>
				</Row>
				{info.pdfIds && <div>
					<h2>下载中心</h2>
					{info.pdfArr && info.pdfArr.map( (item, index) => {
						return <FileLine value={item} key={index} />
					})}</div>}
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		padding: 1rem;
		z-index: 10;
		position: relative;

		.inner-content {
			display: flex;
			justify-content: space-between;
			margin-top: .5rem;

			.ant-image {
				padding: .3rem;
				border: 1px solid #ccc;
			}
		}

	}
`;
